import React, { useState } from "react";
import "../../index.css";
import "./contactus.css";
import EmbeddedFormContact from "../../popUpForms/embeddedFormContact";
import EmbeddedFormModal from "../../popUpForms/formModals/embeddedFormModal";

const ContactUs = () => {
  return (
    <div className="contactus-form ">
      <h2>Contact Us</h2>
      <div className="form-wrapper">
        <EmbeddedFormModal>
          <EmbeddedFormContact />
        </EmbeddedFormModal>
      </div>
    </div>
  );
};

export default ContactUs;
